"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnMultiSelectFilterConfig = void 0;
const react_1 = require("react");
const table_columns_1 = require("../../table-columns");
const use_strategy_values_short_list_hook_1 = require("../client/use-strategy-values-short-list.hook");
const client_constants_1 = require("../../../client/client.constants");
const attributes_1 = require("../../../constants/attributes");
const models_1 = require("../../../models");
const localization_1 = require("../../../../localization");
// TODO: EN-4809 - remove after table migration
/** @deprecated - Use useMultiSelectColumnFilterSortConfig instead */
const useColumnMultiSelectFilterConfig = (productTreeNodeId) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { getStrategyValuesShortList, isLoading, } = (0, use_strategy_values_short_list_hook_1.useGetStrategyValuesShortList)({
        pageSize: client_constants_1.REQUEST_LIMIT_MAX, sortingItem: models_1.SortingItem.SortByTextAsc, options: { fetchPolicy: 'cache-first' }, productTreeNodeId,
    });
    const getFilterOptions = (0, react_1.useCallback)((id) => __awaiter(void 0, void 0, void 0, function* () {
        const options = yield getStrategyValuesShortList((0, table_columns_1.parseColumnId)(id).label);
        return [
            ...options,
            {
                label: t({ key: 'UNKNOWN' }),
                value: attributes_1.SpecialAttributeValue.Unknown,
            },
            {
                label: t({ key: 'NOT_APPLICABLE_SHORT' }),
                value: attributes_1.SpecialAttributeValue.NotApplicable,
            },
        ];
    }), [getStrategyValuesShortList, t]);
    // 'Unknown' and any other value are mutually exclusive, if both are selected then no results will be returned from query.
    // Need to ensure that both of them are not selected at the same time.
    const getFilterChangeHandler = (id) => (value) => {
        // Unknown is selectable only if no other value is selected
        if (value.includes(attributes_1.SpecialAttributeValue.Unknown) && value.length === 1) {
            return { field: id, list: [attributes_1.SpecialAttributeValue.Unknown] };
        }
        // If any other value is selected, deselect Unknown
        return { field: id, list: value.filter((v) => v !== attributes_1.SpecialAttributeValue.Unknown) };
    };
    const getFilterConfig = (0, react_1.useCallback)(({ id }) => ({
        key: id,
        searchable: true,
        get: (filters) => { var _a, _b; return (((_b = (_a = filters === null || filters === void 0 ? void 0 : filters.includes) === null || _a === void 0 ? void 0 : _a[id]) === null || _b === void 0 ? void 0 : _b.list) || []); },
        loadOptions: () => getFilterOptions(id),
        areOptionsLoading: isLoading,
        set: getFilterChangeHandler(id),
    }), [isLoading, getFilterOptions]);
    return getFilterConfig;
};
exports.useColumnMultiSelectFilterConfig = useColumnMultiSelectFilterConfig;
